export default __webpack_public_path__ + "2d680712eb88fa6c401b2846a050f0c6.jpeg";